export enum WithdrawTypes {
  ADD_WITHDRAW_SUCCESS = 'ADD_WITHDRAW_SUCCESS',
  ADD_WITHDRAW_FAILURE = 'ADD_WITHDRAW_FAILURE',
  UPDATE_WITHDRAW_SUCCESS = 'UPDATE_WITHDRAW_SUCCESS',

  UPDATE_WITHDRAW_FAILURE = 'UPDATE_WITHDRAW_FAILURE',
  DISABLE_WITHDRAW = 'DISABLE_WITHDRAW',
}
